module.exports = __webpack_public_path__ + "img/prijava.557d72e9.png";